import { BITCOIN_UNIT, SATOSHI_UNIT, SATOSHIS, USD_UNIT, type BsvUnit } from 'lib/bsv-util'

export function normalizeSimpleMoneyUnit(unit: BsvUnit): BsvUnit {
    return unit === USD_UNIT ? USD_UNIT : SATOSHI_UNIT
}

export function simpleMoneyDisplayUnit(
    sats: number | string | null | undefined,
): typeof BITCOIN_UNIT | typeof SATOSHI_UNIT {
    const amount = Number(sats || 0)
    return Number.isFinite(amount) && amount >= SATOSHIS ? BITCOIN_UNIT : SATOSHI_UNIT
}

export function shouldDisplayBitcoin(
    sats: number | string | null | undefined,
    bsvUnit: BsvUnit | string,
    fallbackUnit: typeof BITCOIN_UNIT | typeof SATOSHI_UNIT = SATOSHI_UNIT,
): boolean {
    if (fallbackUnit === BITCOIN_UNIT) return true
    if (bsvUnit === USD_UNIT) return false

    return simpleMoneyDisplayUnit(sats) === BITCOIN_UNIT
}
